'use strict';

// Import Libraries
import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import ReactDOMServer from 'react-dom/server';
import DeliveryOptionCalculator from "../_utils/_delivery-options/calculator";
// Import JS Modules

// -----------------------------------------------------------
//  FilterComparison
// -----------------------------------------------------------
class FilterComparison extends React.Component {

  componentDidMount() {
    if (typeof window !== 'undefined') {
      this.createPopover();
      window.addEventListener('touchend', this.hideFlyoutFromOutsideTouch);
    }
  }

  componentWillUnmount() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('touchend', this.hideFlyoutFromOutsideTouch);
    }
  }

  render() {
    if (this.props.fields.length && this.props.options.some(o => Object.keys(o.comparison_data).length)) {
      return (
        <a ref={ref => this.trigger = ref}
          href="#"
          aria-label="More information about these options"
          tabIndex="0"
          role="button"
          onClick={e => e.preventDefault()}>
          <i className="fa fa-info-circle" />
        </a>
      );
    }

    return null;
  }

  hideFlyoutFromOutsideTouch = (event) => {
    if ($('.popover').length > 0 && $(event.target).closest('.filter-comparison').length === 0) {
      $(ReactDOM.findDOMNode(this.trigger)).popover('hide');
    }
  }

  createPopover() {
    if (!this.trigger) {
      return;
    }

    const $trigger = $(ReactDOM.findDOMNode(this.trigger));

    $trigger.popover({
      container: 'body',
      content: this.popoverHTML,
      html: true,
      placement: 'auto',
      template: ReactDOMServer.renderToString(
        <div className="filter-comparison popover" role="tooltip">
          <div className="arrow" />
          <div className="popover-header" />
          <div className="popover-body" />
        </div>
      ),
      trigger: 'ontouchstart' in window ? 'hover click' : 'hover click'
    });
  }

  get popoverHTML() {
    return this.props.options.map(this.renderOption, this).
      filter(Boolean).
      map(ReactDOMServer.renderToString).
      join('');
  }

  renderOption(option, index) {
    const $rows = this.props.fields.slice(1).map((field, index) => this.renderRow(option, field, index)).
      filter(Boolean);

    if ($rows.length) {
      return (
        <div key={index} className='comparison'>
          {this.renderHeader(option, this.props.fields[0])}
          <div className="row">
            {
              this.context.useIconsInComparisonFields && option.image ? (
                <div className="col-4">
                  <img className="img-fluid comparison-image" src={option.image} />
                </div>
              ) : null
            }
            <div className="col">
              <ul>
                {$rows}
              </ul>
            </div>
          </div>
        </div>
      );
    }
  }

  renderHeader(option, field) {
    const data = this.comparisonData(option, field);

    if (data) {
      return (
        <p className='comparison-header m-0'>
          {data}
          {this.getDeliveryOptionsIconsForKeys(
            this.deliveryOptionsForFilterField(option),
            this.props.deliveryOptions
          )}
        </p>
      );
    }

    return null;
  }

  renderRow(option, field, index) {
    const data = this.comparisonData(option, field);

    if (data) {
      return (
        <li key={index}>
          {data}
        </li>
      );
    }

    return null;
  }

  getDeliveryOptionsIconsForKeys(deliveryOptionsForFilter, deliveryOptions) {
    const { hasShipping, hasOneHourPickup, hasSameDayPickup } = DeliveryOptionCalculator.productsDeliveryOptionsTiers(deliveryOptionsForFilter, deliveryOptions);

    return (
      <span>
        {hasShipping ? <i className="fas fa-truck" /> : null}
        {hasOneHourPickup ? <i className="far fa-clock" /> : null}
        {hasSameDayPickup ? <i className="fas fa-store" /> : null}
      </span>
    );
  }

  comparisonData(option, field) {
    return (option.comparison_data || {})[field];
  }

  deliveryOptionsForFilterField(option) {
    const deliveryOptionsForFilter = [];

    (this.props.products || []).forEach(function (item) {
      for (let key in item.filters) {
        if (item.filters.hasOwnProperty(key) && (item.filters[key] === option.title)) {
          item.delivery_options.forEach(function (opt) {
            if (deliveryOptionsForFilter.indexOf(opt) === -1) {
              deliveryOptionsForFilter.push(opt);
            }
          })
        }
      }
    });

    return deliveryOptionsForFilter;
  }
}

FilterComparison.contextTypes = {
  useIconsInComparisonFields: PropTypes.bool
};

export default FilterComparison;
